module.exports = __webpack_public_path__ + "img/miniapp-icon.2cbc5b8c.png";